"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qrcode = _interopRequireDefault(require("qrcode"));
var _vuex = require("vuex");
var _user = require("@/api/crm/user");
var _default = exports.default = {
  data() {
    return {
      isMobile: false,
      message: {},
      qrCodeData: ''
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['userId'])
  },
  created() {
    this.getMessage();
    this.generateQRCode();
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    async getMessage() {
      this.message = await (0, _user.getBusinessCard)({
        userId: this.$route.query.userId ? this.$route.query.userId : this.userId
      });
    },
    generateQRCode() {
      const options = {
        color: {
          dark: '#000',
          // 设置前景色
          light: '#fff' // 设置背景色
        }
      };
      _qrcode.default.toDataURL(location.href, options).then(url => {
        this.qrCodeData = url;
      });
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768 ? true : false;
    }
  }
};